import React from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Header from '../../../component/common/LeaveHeader';
import Loader from '../../../component/common/Loader';
import CONSTANT from '../../../constant';

import { bulkUpdateBalance } from '../../../actions/UnitLeaveAction'
import { getLeaveType } from '../../../actions/MasterAction'
import NumberFormat from 'react-number-format';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const value = queryString.parse(this.props.location.search);
        this.state = {
            leaveDetailArr: [],
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
        getLeaveType().then((res: any) => {
            const filtered = res.result.filter((i: any) => i.code !== CONSTANT.static.leaveType.cml);
            this.setState({
                leaveDetailArr: filtered.map((i: any) => { return { ...i, value: '', error: '' } })
            });
        })
    }

    render() {
        const { leaveDetailArr, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Update Leave Balance</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                {
                                                    leaveDetailArr.map((item: any, index: number) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <div className="col-md-4" key={index}>
                                                                    <div className="form-group">
                                                                        <label>{item.name}</label>
                                                                        <NumberFormat
                                                                            data-code={item.code}
                                                                            className={item.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                            placeholder={`Number of ${item.name}`}
                                                                            name={item.name}
                                                                            value={item.value}
                                                                            onChange={this.onArrayItemChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <p>* Note: Enter 0 if you dont want to update the value</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <Link to={CONSTANT.component.unitLeaveReport.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                                </div>
                                                <div className="col-md-6">
                                                    &nbsp;
                                                </div>
                                                <div className="col-md-3">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onArrayItemChange = (e: any) => {
        const value = parseFloat(e.target.value);
        const code = parseFloat(e.target.dataset.code);
        const _tempArr = JSON.parse(JSON.stringify(this.state.leaveDetailArr));
        const updatedArr = _tempArr.map((i: any) => {
            if (i.code === code) {
                i.value = value;
            }
            return i;
        });
        this.setState({ leaveDetailArr: updatedArr });
    }

    onSubmit = (e: any) => {
        e.preventDefault();

        if (this.validateForm()) {
            this.setState({ showLoader: true });
            const { leaveDetailArr } = this.state;
            const model = { leaveType: leaveDetailArr }
            bulkUpdateBalance(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.status === CONSTANT.static.apiStatus.success) {
                    alert('Leave updated successfully');
                    this.props.history.push(CONSTANT.component.adminLeaveManager.url);
                } else {
                    alert(res.error);
                }
            })
        }
    }

    validateForm = () => {
        const { leaveDetailArr } = this.state;
        const clone = JSON.parse(JSON.stringify(leaveDetailArr));
        let status = true;
        for (let i = 0; i < clone.length; i++) {
            if (clone[i].value.length === 0) {
                clone[i].error = 'error';
                status = false;
            } else {
                clone[i].error = '';
            }
        }
        this.setState({ leaveDetailArr: clone });
        return status;
    }
}

export default ComponentName;